const DRAWER_BANNER_HEIGHT = 80;
const PAGE_FRAME_HEIGHT = "calc(100vh - var(--page-content-top, 13px))";
const DEACTIVATION_GRACE_PERIOD_DAYS = 90;

export {
  PAGE_FRAME_HEIGHT,
  DRAWER_BANNER_HEIGHT,
  DEACTIVATION_GRACE_PERIOD_DAYS,
};
